import React, { useState, useEffect, useContext } from 'react';
import {format, addDays, subDays} from "date-fns";

import * as net from "../../../../lib/net";
import Fr_Input from "../../../../lib/ui/fr_input";
import Fr_Select from "../../../../lib/ui/fr_select";
import Dt_Cal from "../../../../lib/ui/dt_cal";

class Doc_FreeText extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.pms = props.store.pms;

    this.state = {};
    this.state.today = new Date();
    this.state.rta = [];
    this.state.pka = [];

    this.state.gnr = "001";
    this.state.bokr00 = {};
    this.state.bokr01 = {};
    this.state.konf01 = {};
    //this.state.lro = props.lro;
    this.state.ynq = [
                {id: '0', text: 'NEJ'},
                {id: '1', text: 'JA'}
            ];

    this.state.bgo = {};
    this.state.bto = {};
    this.state.background = "#fff";

    this.state.cols = {};
    this.state.lrwrk = false;
    this.state.boknr = {};
    if(props.wnds) this.state.boknr = props.wnds.boknr;
    this.state.dro = {};
    if(props.dro) this.state.dro = props.dro;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.row_init();
    //this.rts();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    grp_style(row) {
      var css = {};
      css.background = "#008";
      if(this.state.gnr === row.vgrupp) css.background = "#080";
      return css;
    }

    formchange (e) {
      const name = e.target.name;
      const value = e.target.value;
      var pbo = this.state.pbo;
      var na = name.split(".");
      pbo[na[0]][na[1]] = value;
      this.setState({pbo: pbo});
      //setState({[name]: value});
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close = () => {
		//this.props.ctx.setState({ rvbradd: false });
        var ret = {};
        ret.ok = "999";
        this.props.cb(this.props.ctx, ret);
	};
    handleChange = (event, newValue) => {
        //alert(newValue);
        this.setState({ix: newValue});
      };
    toggle() {
      this.setState({modal: false});
	};

  submitHandler = event => {
    event.preventDefault();
    event.target.className += " was-validated";
  };

  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

    rsv_save (name, value) {
        //alert(JSON.stringify(name));
        //alert(JSON.stringify(value));
      var rsv = this.state.bro;
      var na = name.split(".");
      rsv[na[0]][na[1]] = value;
      this.setState({rsv: rsv});
      //setState({[name]: value});
    }
    val_save (name, value) {
        //alert(JSON.stringify(name));
        //alert(JSON.stringify(value));
      var dro = this.state.dro;
      dro[name] = value;
      this.setState({dro: dro});
      //setState({[name]: value});
    }
    cb_save (name, e) {
      const value = e.target.value;
      var dro = this.state.dro;
      dro[name] = value;
      this.setState({dro: dro});
      //setState({[name]: value});
    }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }

  row_init() {
    var self = this;
    var datum = format(this.state.today, "yyyy-MM-dd");

    var dro = {};
    dro.datum = datum;
    dro.tid = "";
    dro.text = "";
    dro.antal = "";

    var bokr00 = {};
	bokr00.resno = this.state.boknr;
	bokr00.lopnr = "00001";
	bokr00.radnr = "0001";
	bokr00.resurs = "HOT";
	bokr00.restyp = "M001";
	bokr00.datum = "";
	bokr00.start = "";
	bokr00.slut = "";
	bokr00.text = "";
	bokr00.antal = "";
	bokr00.belopp = "";

    var bokr01 = {};
	bokr01.apris = "";
	bokr01.fakturanr = "";

    var konf01 = {};
	konf01.r0typ = "M";
	konf01.r0datum = "";
	konf01.r0lopnr = "001";
	konf01.r0plunr = "";
	konf01.r0text = "";
	konf01.r0antal = "";
	konf01.r0pris = "";
	konf01.r0tid = "";
	konf01.r0kat = "";

    this.setState({dro: dro, bokr00: bokr00, bokr01: bokr01, konf01: konf01});
  }
  rts() {
    var self = this;
    var prm = {};
    prm.req = "pms.rt.rt_date";
    //prm.datum = this.state.datum;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(ret.ok != "000") {
            return;
        }
        self.setState({rta: ret.rco});
        self.pkats();
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }

  doc_row_add() {
    var self = this;

    var bokr00 = this.state.bokr00;
	bokr00.datum = this.state.dro.datum.replace(/-/g,"");
	bokr00.start = this.state.dro.tid;
	bokr00.slut = this.state.dro.tid;
	bokr00.text = this.state.dro.text;
	bokr00.antal = this.state.dro.antal;
    var bokr01 = this.state.bokr01;

    var konf01 = this.state.konf01;
	konf01.r0datum = this.state.dro.datum.replace(/-/g,"");
	konf01.r0tid = this.state.dro.tid;
	konf01.r0text = this.state.dro.text;
	konf01.r0antal = this.state.dro.antal;

    //alert(JSON.stringify(this.state.dro));
    alert(JSON.stringify(bokr00));
    alert(JSON.stringify(konf01));
    //return;

    var prm = {};
    prm.req = "pms.doc.doc_row_add";
    prm.boknr = this.state.boknr;
    prm.bokr00 = bokr00;
    prm.bokr01 = bokr01;
    prm.konf01 = konf01;
    //prm.nyp00 = this.state.nyp00;
    //alert(JSON.stringify(prm));
    //return;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(ret.ok == "000") {
		    self.props.cb(self.props.ctx, ret);
            return;
        }
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  render() {
    //if(!this.props.show) return "";

    var title = this.props.title;
    if(!title) title = "Delbokning";
    //if(props.kro) alert(props.kro.krr00.kid);
    const popover = {
      position: 'absolute',
      top: '50px',
      zIndex: '2',
    }
    const cover = {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    }

	var html =
        <div className="mx_base">
        <div className="m2_backdrop" />
        <div className="m2_dlg mx_70 flex-col" style={ this.dlg_style() } draggable="true" >

        <div className="mx_h01">
            <div>FRITEXT</div>
        </div>
        <div className="mx_content flex">

            <div className="flex-row" style={{padding:"5px",height:"35px"}}>
                    <div className="flex-col flex">
                        <div></div>
                    </div>
                    <div className="flex-col">
                        <div>UPPDATERA</div>
                    </div>
            </div>
            <div className="divider_orange"></div>

            <form className="cdi_f03">
            <div className="flex-row py-2">
                    <Fr_Input label="Datum" className="text-left w250" text={this.state.dro.datum} getValue={(e)=> this.val_save("datum", e) } />
            </div>
            <div className="flex-row py-2">
                    <Fr_Input label="Tid" className="text-left w150" text={this.state.dro.tid} getValue={(e)=> this.val_save("tid", e) } />
            </div>
            <div className="divider_green"></div>
            <div className="flex-row py-2">
                    <Fr_Input label="Text" className="text-left w350" text={this.state.dro.text} getValue={(e)=> this.val_save("text", e) } />
            </div>
            <div className="flex-row py-2">
                    <Fr_Input label="Antal" className="text-left w250" text={this.state.dro.nrof} getValue={(e)=> this.val_save("antal", e) } />
            </div>
            </form>

        </div>

        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                AVBRYT
            </button>
            <div className="flex-row">
            <button className="btn btn-hw-red w250" onClick={() => this.doc_row_add() } >
                LÄGG TILL
            </button>
            </div>
        </div>
      </div>
      </div>
	;
	return html;
  };
}

export default Doc_FreeText;